'use strict';

import React, { Component } from 'react';
import { withRouter, Switch } from 'react-router-dom';
const app = window.app;
class AppWrapper extends Component {
  constructor(props) {
    super(props);
    if (app) {
      app.router_history = props.history;
    }
  }
  UNSAFE_componentWillUpdate(next_props, next_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.location.pathname !== next_props.location.pathname) {
      window.scrollTo(0, 0);
      app.emit({
        event: 'pageChange',
        source: 'AppWrapper'
      });
    }
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    return /*#__PURE__*/React.createElement(Switch, null, " ", props.routes, " ");
  }
}
export default withRouter(props => /*#__PURE__*/React.createElement(AppWrapper, props));
